import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@mui/material/SvgIcon';

import styles from '../css/app.module.css';

function CloseIcon(props) {
  return (
    <SvgIcon viewBox="0 0 16 16" style={{color: '#fff', fontSize: 20}} {...props}>
      <path d="M9.29297 7.75L13.7188 3.36719L14.6211 2.46484C14.75 2.33594 14.75 2.12109 14.6211 1.94922L13.6758 1.00391C13.5039 0.875 13.2891 0.875 13.1602 1.00391L7.875 6.33203L2.54688 1.00391C2.41797 0.875 2.20312 0.875 2.03125 1.00391L1.08594 1.94922C0.957031 2.12109 0.957031 2.33594 1.08594 2.46484L6.41406 7.75L1.08594 13.0781C0.957031 13.207 0.957031 13.4219 1.08594 13.5938L2.03125 14.5391C2.20312 14.668 2.41797 14.668 2.54688 14.5391L7.875 9.21094L12.2578 13.6367L13.1602 14.5391C13.2891 14.668 13.5039 14.668 13.6758 14.5391L14.6211 13.5938C14.75 13.4219 14.75 13.207 14.6211 13.0781L9.29297 7.75Z" />
    </SvgIcon>
  );
}

const ProductStepper = ({onClickClose}) => {
  return (
    <div className={styles['product-stepper']}>
      <h2 className="clr-white">Pen Settings</h2>

      <div className={styles['product-stepper-actions']}>
        <CloseIcon className={styles['product-stepper-action']} onClick={onClickClose} />
      </div>
    </div>
  );
};

ProductStepper.propTypes = {
  onClickClose: PropTypes.func.isRequired,
};

export default ProductStepper;
